import React from 'react';

import { TableCell, TableRow, Skeleton } from '@mui/material';

type Props = {
  rowCount: number;
  cellCount: number;
  id: string;
};

/**
 * Skeleton component to display while a table is loading.
 * @param rowCount The number of rows to display
 * @param cellCount The number of cells to display in each row
 * @param id The ID of the row
 */
export const SkeletonTableRow = ({ rowCount, cellCount, id }: Props) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, i) => (
        <TableRow id={`${id}-row-${i}`} data-testid={id} key={i}>
          {Array.from({ length: cellCount }).map((_, iCell) => (
            <TableCell id={`${id}-cell-${iCell}`} key={iCell}>
              <Skeleton animation="wave" key={iCell} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
